import { Button } from "@/components/ui/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { Info } from "lucide-react";
import { useFieldArray } from "react-hook-form";
import { ParameterFormProps } from ".";
import { ParameterRow } from "../../molecules/ParameterRow";



export function ParameterForm({
    label,
    description = "Make changes to your configuration here",
    form,
    parameterName,
}: Readonly<ParameterFormProps>) {
    const { fields, append, remove } = useFieldArray({
        control: form.control,
        name: `parameter.${parameterName}`,
    });

    const appendParameter = () => {
        const id = globalThis.crypto.randomUUID();
        append({ id, name: "" });
    }

    const deleteParameter = (index: number) => {
        remove(index);
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle>{label}</CardTitle>
                <CardDescription>
                    <div className="flex items-center text-blue-600">
                        <Info className="flex-shrink-0 me-1" size="16" />
                        <p className="text-xs">{description}</p>
                    </div>
                </CardDescription>
            </CardHeader>
            <CardContent >
                <Form {...form}>
                    <form className="space-y-2">
                        {fields.map((field, index) => (
                            <ParameterRow key={field.id}
                                index={index}
                                form={form}
                                parameterName={parameterName}
                                deleteParameter={deleteParameter}
                            />
                        ))}
                    </form>
                </Form>
            </CardContent>
            <CardFooter>
                <div className="flex justify-end w-full">
                    <Button
                        type="button"
                        size='sm'
                        className="text-xs"
                        onClick={(e) => {
                            e.preventDefault()
                            appendParameter()
                        }}
                    >
                        Add element
                    </Button>
                </div>
            </CardFooter>
        </Card>
    )
}

